module.exports = __webpack_public_path__ + "static/img/mingshi_banner.aaf50ea3.png";